import api from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useAdminBadgeCount } from './useAdminBadgeCount';

/**
 * Number of arches awaiting human review (escalated plugin reviews). Drives the
 * admin "needs review" alert that surfaces on the user menu, the Dev Console
 * dashboard, and the Plugin Review Queue.
 */
export function usePendingPluginReviewCount(): number {
  return useAdminBadgeCount(queryKeys.submissions.escalatedCount(), () =>
    api.getEscalatedPluginReviewCount(),
  );
}
